export default __webpack_public_path__ + "static/media/pantry2-after1-1920w.1efc271d.png";